import React from "react";
import DefaultChainLogo from "assets/img/ChainParentDefaultLogo.png";
import ResetIQLogo from "assets/img/Reset IQ - Powered By A-B.png";

const QrPdfTemplate = ({
  store,
  qrDataUrl,
  qrFileUrl,
  containerId = "qr-pdf",
  fileLogo,
}: {
  store: any;
  qrDataUrl: string;
  qrFileUrl: string;
  containerId?: string;
  fileLogo?: string; 
}) => {
  const showLogo =
  fileLogo &&
  fileLogo !== DefaultChainLogo &&
  fileLogo !== "";
  return (
    <div
      id={containerId}
      style={{
        position: "fixed",
        top: "-2000px",
        left: 0,
        width: "420px",
        padding: "24px",
        background: "#fff",
        fontFamily: "Arial",
        boxSizing: "border-box",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "#E5B611",
          padding: "12px",
          color: "#fff",
          fontSize: "18px",
          fontWeight: 600,
          textAlign: "center",
          borderRadius: "6px",
        }}
      >
        {store.chain_name} <br/>
        Store # {store.store_number || store.retail_store_num}
      </div>
      
      <div
        style={{
          marginTop: "64px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* <h3 style={{ marginBottom: "16px" }}>Scan to Download</h3> */}



<div
  style={{
    position: "relative",
    width: "270px",
    height: "270px",
    borderStyle: "solid",
    borderColor: "#d2d2d2ff",
    borderWidth: "8px 8px 28px 8px",
    borderRadius: "20px",
    boxSizing: "border-box",
    background: "#d2d2d2ff", 
  }}
>
  <div
    style={{
      position: "absolute",
      top: "8px",
      left: "8px",
      right: "8px",
      bottom: "18px",
      background: "#fff",
      borderRadius: "12px", 
      padding: "10px",
      boxSizing: "border-box",
    }}
  >
    <img
      src={qrDataUrl}
      alt="qr"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        imageRendering: "crisp-edges",
        borderRadius: "6px",
        maxWidth: "100%",
        maxHeight: "100%",
      }}
    />
  </div>

    {showLogo && (
    <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        width: "52px",
        height: "52px",
        transform: "translate(-50%, -50%)",
        background: "#fff",
        padding: "6px",
        borderRadius: "8px",
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
          src={fileLogo || DefaultChainLogo}
          alt="chain-logo"
          style={{
          width: "auto",
          height: "auto",
          maxWidth: "40px",
          maxHeight: "40px",
          objectFit: "contain",
        }}
    />
    </div>
    )}


  <div
    style={{
      position: "absolute",
      bottom: "-24px",
      left: "50%",
      transform: "translateX(-50%)",
      background: "#d2d2d2ff",
      color: "#fff",
      fontSize: "16px",
      fontWeight: 600,
      whiteSpace: "nowrap",
      padding: "0px 10px",
      borderRadius: "6px",
      zIndex: 1,
    }}
  >
    {/* <img src={ResetIQLogo} alt=""/> */}
    <img
  src={ResetIQLogo}
  alt="ResetIQ"
  style={{
    height: "36px",
    width: "auto",
    objectFit: "contain",
    display: "block",
    maxWidth: "100%",
  }}
/>

  </div>
</div>

        <p
          style={{
            marginTop: "20px",
            fontSize: "12px",
            color: "#555",
            wordBreak: "break-all",
          }}
        >
          Scan to view Store PDF
        </p>
      </div>
    </div>
  );
};

export default QrPdfTemplate;
